import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useUpdateItemSupplier = () => useMutation({
        mutationFn: ordersRecognitionApi.updateItemSupplier,
    })
